import React, { useState, useRef } from "react";
import ReactDOM from "react-dom";
import Button from "@/components/Button";
import ReactEasyCrop from "react-easy-crop";

function BannerEditorModal({ data, imageUrl, onClose, onSubmit }) {
  const [crop, setCrop] = useState({
    x: data?.image_config?.x ?? 0,
    y: data?.image_config?.y ?? 0,
  });
  const [zoom, setZoom] = useState(data?.image_config?.zoom_scale ?? 1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const cropperRef = useRef(null);

  const onCropChange = (newCrop) => {
    setCrop(newCrop);
  };

  const onZoomChange = (newZoom) => {
    setZoom(newZoom);
  };

  const onCropComplete = (_, croppedArea) => {
    setCroppedAreaPixels(croppedArea);
  };

  const handleSave = async () => {
    if (croppedAreaPixels) {
      onSubmit({
        ...data,
        image_config: {
          x: crop?.x,
          y: crop?.y,
          zoom_scale: zoom,
        },
      });
    }
  };
  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999999]">
      <div className="flex flex-col gap-y-2 w-[1300px] py-4 items-center rounded-7 bg-white">
        <h1 className="text-xl">Image Editor - Banner</h1>
        <div className="bg-neutral-100 border-4 border-[#f7df44] w-[1280px] flex items-center justify-center relative h-[325px] overflow-hidden">
          <div className="w-px z-50 h-full absolute bg-red-600 start-[98.75px]"></div>
          <div className="w-px z-50 h-full absolute bg-red-600 start-[148.125px]"></div>
          <div className="w-px z-50 h-full absolute bg-red-600 end-[60px]"></div>
          <div className="w-px z-50 h-full absolute bg-red-600 end-[40px]"></div>
          <div className="w-full z-50 h-px absolute bg-red-600 top-[58px]"></div>
          <div className="w-full z-50 h-px absolute bg-red-600 bottom-[58px]"></div>

          {imageUrl && (
            <ReactEasyCrop
              image={imageUrl}
              crop={crop}
              zoom={zoom}
              showGrid={false}
              cropSize={{ width: 1280, height: 325 }}
              aspect={1280 / 325}
              onCropChange={onCropChange}
              onZoomChange={onZoomChange}
              onCropComplete={onCropComplete}
              cropperRef={cropperRef}
              className="absolute"
            />
          )}
        </div>
        <div className="mt-4 w-full gap-x-10 flex justify-center">
          <div className="w-1/4">
            <Button
              onClick={onClose}
              variant="outlined"
              label="Cancel"
              type="button"
            />
          </div>
          <div className="w-1/4">
            <Button
              onClick={handleSave}
              variant="green-gradient"
              label={"Save"}
              type="submit"
            />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default BannerEditorModal;
